import { render, staticRenderFns } from "./generic.vue?vue&type=template&id=a371a18e&scoped=true&lang=pug&"
import script from "./generic.vue?vue&type=script&lang=js&"
export * from "./generic.vue?vue&type=script&lang=js&"
import style0 from "./generic.vue?vue&type=style&index=0&id=a371a18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a371a18e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/list-item.vue').default})
